import { useMutation } from 'react-query';
import { Button } from 'semantic-ui-react';
import toast from 'react-hot-toast';

import { exportHubspot } from '~/api/admin';

export default function DownloadHubspot() {
  const { mutate: requestHubspotExport, status } = useMutation(async () => {
    try {
      const result = await exportHubspot();
      toast.success(result.message);
    } catch (err) {
      console.error(err);
      toast.error('An error occurred while requesting the HubSpot export. Please refresh the page and try again');
    }
  });

  return (
    <Button
      primary
      size="small"
      disabled={status === 'loading'}
      loading={status === 'loading'}
      onClick={() => requestHubspotExport()}
    >
      Request HubSpot Export
    </Button>
  );
}
